import { trans } from '@/i18n';
import { msgMaxLength } from '@/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const schema = yup.object({
  name: yup
    .string()
    .max(255, msgMaxLength(255, trans('plan.name')))
    .required(trans('plan.formValidation.nameRequired'))
    .test('empty', trans('plan.formValidation.nameRequired'), (value) => {
      return value ? value.trim() !== '' : false;
    }),
  price: yup
    .number()
    .typeError(trans('plan.formValidation.priceNumber'))
    .integer(trans('plan.formValidation.priceInteger'))
    .min(0, trans('plan.formValidation.priceMin'))
    .max(10000000000, trans('plan.formValidation.priceMax'))
    .required(trans('plan.formValidation.priceRequired')),
  description: yup
    .string()
    .max(512, msgMaxLength(255, trans('plan.description')))
    .optional(),
});

const createPlanYup = yupResolver(schema) as any;
export default createPlanYup;
